import React, { Component } from 'react';
import SDelivery from './SDelivery.js';
import axios from 'axios';
import { MENU } from '../Sidebar.js';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';

export const STATUS = {
  PENDING: "1",
  APPROVED: "2",
  REJECTED: "3",
  CANCELED: "4",
  FORCED: "5"
};

let cancelToken;
let state;
let tokenSession;

class SDeliveryContainer extends Component {

  constructor(props) {
    super(props);
    if (tokenSession !== props.getTokenSession()) {
      state = this.getInitState();
    }
    this.state = state;
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
  }

  componentDidMount() {
    this.reload();
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
    state = this.state;
    tokenSession = this.props.getTokenSession();
  }

  didGetSDeliveries(response) {
    this.setState({
      sdeliveries_pendientes: response.pendientes,
      sdeliveries_actualizadas: response.actualizadas
    });
  }

  getInitState = () => {
    return {
      sdeliveries_pendientes: null,
      sdeliveries_actualizadas: null
    };
  }

  getSDeliveries = (params) => {
    this.props.post(
      "/getServicesDelivery",
      params,
      (response) => this.didGetSDeliveries(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  reload = () => {
    this.getSDeliveries({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });
  }

  renderSDelivery = () => {
    return(
      <SDelivery
        sdeliveries_pendientes={this.state.sdeliveries_pendientes}
        sdeliveries_actualizadas={this.state.sdeliveries_actualizadas}
      />
    );
  }

  render() {
    const { t } = this.props;
    const permissionStatus = this.props.getPermissionStatus(MENU.SDELIVERY);

    return(
      <div>
        <h2 className="page-header">{t('dashboard.sdelivery.heading')}</h2>
        {permissionStatus && <div className="jumbotron alert-warning">{permissionStatus}</div>}
        {!permissionStatus && this.renderSDelivery()}
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(SDeliveryContainer);



// WEBPACK FOOTER //
// ./src/dashboard/sdelivery/SDeliveryContainer.js